<div class="container-fluid p-4">
  <!-- Header -->
  <div class="page-header">
    <div>
      <h2><i class="bi bi-pie-chart me-2"></i>Centros de Custo</h2>
      <p class="text-muted mb-0">Organize despesas e receitas por centro de custo</p>
    </div>
    <button class="btn btn-primary btn-sm" (click)="openModal()">
      <i class="bi bi-plus-circle me-1"></i> Novo Centro de Custo
    </button>
  </div>
  <hr/>

  <!-- Filtros -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-2">
        <div class="col-md-6">
          <input type="text" class="form-control" placeholder="🔍 Buscar por nome..."
                 [value]="filter.search" (input)="onSearch($any($event.target).value)">
        </div>
        <div class="col-md-3">
          <select class="form-select" [value]="filter.isActive === null ? '' : filter.isActive"
                  (change)="onStatusChange($any($event.target).value)">
            <option value="">Todos</option>
            <option value="true">Ativos</option>
            <option value="false">Inativos</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela -->
  <div class="card">
    <div class="card-body">
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border" role="status"></div>
      </div>

      <div *ngIf="!loading && result.items.length === 0" class="text-center py-5 text-muted">
        <i class="bi bi-inbox" style="font-size: 3rem;"></i>
        <p class="mt-2">Nenhum centro de custo encontrado</p>
      </div>

      <table *ngIf="!loading && result.items.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Descrição</th>
            <th>Centro Pai</th>
            <th>Gera Receita</th>
            <th>Status</th>
            <th class="text-end">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of result.items">
            <td><strong>{{ c.name }}</strong></td>
            <td>{{ c.description || '-' }}</td>
            <td>{{ c.parentName || '-' }}</td>
            <td>
              <span class="badge" [class.bg-success]="c.generatesRevenue" [class.bg-secondary]="!c.generatesRevenue">
                {{ c.generatesRevenue ? 'Sim' : 'Não' }}
              </span>
            </td>
            <td>
              <span class="badge" [class.bg-success]="c.isActive" [class.bg-secondary]="!c.isActive">
                {{ c.isActive ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
            <td class="text-end">
              <button class="btn btn-sm btn-outline-primary me-1" (click)="openModal(c)" title="Editar">
                <i class="bi bi-pencil"></i>
              </button>
              <button class="btn btn-sm btn-outline-danger" (click)="delete(c)" [title]="c.isActive ? 'Inativar' : 'Ativar'">
                <i class="bi" [class.bi-x-circle]="c.isActive" [class.bi-check-circle]="!c.isActive"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Paginação -->
      <div *ngIf="result.totalCount > result.pageSize" class="d-flex justify-content-between align-items-center mt-3">
        <div class="text-muted">
          Exibindo {{ result.items.length }} de {{ result.totalCount }} registros
        </div>
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="result.page === 1">
              <a class="page-link" (click)="result.page > 1 && onPageChange(result.page - 1)">Anterior</a>
            </li>
            <li class="page-item" *ngFor="let p of [].constructor(result.totalPages); let i = index"
                [class.active]="i + 1 === result.page">
              <a class="page-link" (click)="onPageChange(i + 1)">{{ i + 1 }}</a>
            </li>
            <li class="page-item" [class.disabled]="result.page === result.totalPages">
              <a class="page-link" (click)="result.page < result.totalPages && onPageChange(result.page + 1)">Próximo</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ editingId ? 'Editar' : 'Novo' }} Centro de Custo</h5>
        <button type="button" class="btn-close" (click)="showModal = false"></button>
      </div>
      <div class="modal-body">
        <div class="row g-3">
          <div class="col-md-12">
            <label class="form-label">Nome <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="form.name">
          </div>
          <div class="col-md-12">
            <label class="form-label">Descrição</label>
            <textarea class="form-control" [(ngModel)]="form.description" rows="2"></textarea>
          </div>
          <div class="col-md-6">
            <label class="form-label">Gera Receita?</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" [(ngModel)]="form.generatesRevenue" id="generatesRevenue">
              <label class="form-check-label" for="generatesRevenue">
                {{ form.generatesRevenue ? 'Sim' : 'Não' }}
              </label>
            </div>
          </div>
          <div class="col-md-12">
            <label class="form-label">Centro de Custo Pai <small class="text-muted">(opcional para criar subcategorias)</small></label>

            <!-- Centro selecionado -->
            <div *ngIf="selectedParent" class="selected-parent-box mb-2">
              <div class="d-flex align-items-center justify-content-between p-2 border rounded bg-light">
                <div>
                  <strong>{{ selectedParent.name }}</strong>
                </div>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="clearParent()" title="Remover">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

            <!-- Campo de busca -->
            <div class="position-relative" *ngIf="!selectedParent">
              <input type="text" class="form-control"
                     [(ngModel)]="parentSearchTerm"
                     (input)="onParentSearchChange(parentSearchTerm)"
                     (focus)="focusParentSearch()"
                     placeholder="🔍 Buscar centro de custo pai...">

              <!-- Backdrop invisível para fechar dropdown -->
              <div *ngIf="showParentDropdown"
                   style="position: fixed; inset: 0; z-index: 999;"
                   (click)="showParentDropdown = false"></div>

              <!-- Dropdown de centros de custo -->
              <div class="parent-dropdown" *ngIf="showParentDropdown">
                <div class="parent-dropdown-item"
                     *ngFor="let cc of filteredCostCenters.slice(0, 10)"
                     (click)="selectParent(cc)">
                  <strong>{{ cc.name }}</strong>
                  <small class="text-muted ms-2" *ngIf="cc.description">{{ cc.description }}</small>
                </div>
                <div class="parent-dropdown-item text-muted" *ngIf="filteredCostCenters.length === 0">
                  Nenhum centro de custo encontrado
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="showModal = false" [disabled]="saving">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
          Salvar
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade" [class.show]="showModal" *ngIf="showModal"></div>
